import { useState, useEffect } from "react"
import { useUpdateMessageMutation, useDeleteMessageMutation } from "./messageApiSlice"
import { useNavigate, useParams } from "react-router-dom"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowAltCircleRight, faCopy, faSave, faTrashCan } from "@fortawesome/free-solid-svg-icons"
import useAuth from "../../hooks/useAuth"
import ActionsListAddEdit from '../actions/ActionsListAddEdit'
import TimeLeft from '../../partial/TimeLeft'
import Uploader from "../../partial/Uploader"
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css'; // import the styles
import MessageComments from "./MessageComments"

const EditMessageForm = ({ message, groups, usersList }) => {

    const { isTeacher, isAdmin } = useAuth()
    const {groupId, type} = useParams()
    const [updateMessage, {
        isLoading,
        isSuccess,
        isError,
        error
    }] = useUpdateMessageMutation()

    const [deleteMessage, {
        isSuccess: isDelSuccess,
        isError: isDelError,
        error: delerror
    }] = useDeleteMessageMutation()

    const navigate = useNavigate()

    const [title, setTitle] = useState(message.title)
    const [body, setBody] = useState(message.body)
    const [group, setGroup] = useState(message.group)
    const [active, setActive] = useState(message.active)
    const [order, setOrder] = useState(message.order)
    const [specificUsers, setSpecificUsers] = useState(message.specificUsers)
    const [users, setUsers] = useState(message.users)
    const [toDate, setToDate] = useState(new Date(message.toDate))
    const [img, setImg] = useState(message.img)



    useEffect(() => {

        if (isSuccess || isDelSuccess) {
            setTitle('')
            setBody('')
            setGroup('')
            setActive(true)
            setOrder(0)
            navigate(`/${type}/${groupId}/messages`)
        }

    }, [isSuccess, isDelSuccess, navigate])

  
    const canSave = [title, body, group,  toDate].every(Boolean) && !isLoading

    const onSaveMessageClicked = async (e) => {
        if (canSave) {
            await updateMessage({ id: message.id, group, title, body, active, specificUsers, toDate, img, users, order })
        }
    }

    const onDeleteMessageClicked = async () => {
        await deleteMessage({ id: message.id })
    }

    const onUsersChanged = e => {
        const values = Array.from(
            e.target.selectedOptions, //HTMLCollection 
            (option) => option.value
        )
        setUsers(values)
    }
    const created = new Date(message.createdAt).toLocaleString('en-US', { day: 'numeric', month: 'long', year: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' })
    const updated = new Date(message.updatedAt).toLocaleString('en-US', { day: 'numeric', month: 'long', year: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' })

    const options = groups.map(group => {
        return (
            <option
                key={group.id}
                value={group.id}
            > {group.name}</option >
        )
    })

    const usersOptions = usersList?.map(user => {
        return (
            <option
                key={user.id}
                value={user.id}
            > {user.name}</option >
        )
    })


    const errClass = (isError || isDelError) ? "errmsg" : "offscreen"
 
    const errContent = (error?.data?.message || delerror?.data?.message) ?? ''


    let deleteButton = null
    if (isTeacher || isAdmin) {
        deleteButton = (
            <button
                className="icon-button"
                title="Delete"
                onClick={onDeleteMessageClicked}
            >
                <FontAwesomeIcon icon={faTrashCan} />
            </button>
        )
    }

    const content = (
        <>
            <p className={errClass}>{errContent}</p>

            <form className="form" onSubmit={e => e.preventDefault()}>
                <div className="form__title-row">
                    <h2>Edit Message</h2>
                    <div className="form__action-buttons">
                    <button
                            className="icon-button"
                            title="Back to Message"
                            onClick={()=>{navigate(`/${type}/${groupId}/messages`)}}
                        >
                            <FontAwesomeIcon icon={faArrowAltCircleRight} />
                        </button>                      
                        <button
                            className="icon-button"
                            title="Save"
                            onClick={onSaveMessageClicked}
                            disabled={!canSave}
                        >
                            <FontAwesomeIcon icon={faSave} />
                        </button>
                        {deleteButton}
                    </div>
                </div>
                <div className="form-input-container">

                <label className="form__label" htmlFor="title">
                    Title:</label>
                <input
                    className={`form__input  ${!title &&'form__input--incomplete'}`}
                    id="title"
                    name="title"
                    type="text"
                    autoComplete="off"
                    value={title}
                    onChange={(e)=>setTitle(e.target.value)}
                />
                </div>
                <div className="form-input-container">

                <label className="form__label" htmlFor="body">
                    Body:</label>
                    <ReactQuill
                    value={body}
                    onChange={setBody}
                    modules={{
                        toolbar: [
                          [{ 'header': '1'}, {'header': '2'}, {'font': []}],
                         // [{ align: '' }, { align: 'center' }, { align: 'right' }, { align: 'justify' }],
                          [{ 'align': [] }],
                          [{ 'direction': 'rtl' }],   
                          [{size: []}],
                          [{ color: [] }, { background: [] }],
                          ['bold', 'italic', 'underline', 'strike', 'blockquote'],
                          [{'list': 'ordered'}, {'list': 'bullet'}/*,       {'indent': '-1'}, {'indent': '+1'}*/],
                          ['link'],
                          ['clean']
                        ],
                        clipboard: {
                          matchVisual: false,
                        }
                      }}
                    />
                {/* <textarea
                    className={`form__input form__input--text ${!body &&'form__input--incomplete'}`}
                    id="body"
                    name="body"
                    value={body}
                    onChange={(e)=>setBody(e.target.value)}
                /> */}
                </div>
                <Uploader label={'Img'} folderId={'MANAGE_TASKS'} file={img} setFile={setImg} isImg={true} />

                <div className="form-flex">

               
                 <div className="form-input-container">
                 <label className="form__label form__title-row" htmlFor="toDate">
                   <span> To Date:</span> <small > (<TimeLeft endtime={toDate} />)</small> </label>
                <input
                    className={`form__input  ${!toDate &&'form__input--incomplete'}`}
                    id="toDate"
                    name="toDate"
                    type="datetime-local"
                    autoComplete="off"
                    value= {`${toDate.getFullYear().toString()}-${(toDate.getMonth() + 1).toString().padStart(2, 0)}-${toDate.getDate().toString().padStart(2, 0)}T${toDate.getHours().toString().padStart(2, 0)}:${toDate.getMinutes().toString().padStart(2, 0)}`}
                    onChange={(e)=>setToDate(new Date(e.target.value))}
                />
                </div>
                </div>
                <div className="form-flex">
                <div className="form-input-container">
                <label className="form__label form__checkbox-container" htmlFor="group">
                    GROUP:</label>
                <select                
                    id="group"
                    name="group"
                    className={`form__input  ${!group &&'form__input--incomplete'}`}
                    value={group}
                    onChange={(e)=>setGroup(e.target.value)}
                >
                    {options}
                </select>
                    </div>
                    <div className="form-input-container">
                  <label className="form__label" htmlFor="action-order">
                    Order:</label>
                <input
                    className={`form__input `}
                    id="action-order"
                    name="order"
                    type="number"
                    autoComplete="off"
                    value={order}
                    onChange={(e)=>setOrder(e.target.value)}
                />
                </div>
               
                   
                    
                      

                </div>

                <div className="form-flex">
                <div className="form-input-container">
                <label className="form__label form__checkbox-container" htmlFor="specific-users">
                    SPECIFIC USERS:
                    <input
                        className="form__checkbox"
                        id="specific-users"
                        name="specific-users"
                        type="checkbox"
                        checked={specificUsers}
                        onChange={(e)=>setSpecificUsers(prev => !prev)}
                    />
                </label>

                <label className="form__label" htmlFor="users">
        Users:</label>
    <select
        id="users"
        name="users"
        className={`form__select `}
        multiple={true}
        size="3"
        value={users}
        onChange={onUsersChanged}
    >
        {usersOptions}
    </select>                   
                </div>
             
               

     
                </div>
              
                <div className="form-input-container">
                    <div className="form__divider">
                    <label className="form__label form__checkbox-container" htmlFor="user-active">
                    ACTIVE:
                    <input
                        className="form__checkbox"
                        id="user-active"
                        name="user-active"
                        type="checkbox"
                        checked={active}
                        onChange={(e)=>setActive(prev => !prev)}
                    />
                </label>
               
                    </div>
                
                </div>
            </form>
           <MessageComments message={message} />
            {/* <div className="form__divider">
                        <p className="form__created">Created:<br />{created}</p>
                        <p className="form__updated">Updated:<br />{updated}</p>
            </div> */}
        </>
    )

    return content
}

export default EditMessageForm